import { IGame, IGamesStore } from '../store';

import api, { request } from '../../../../api';
import { IErrorsStore } from '../../../errors/store';
import { IStore } from '../../../index';

export const updateGamePlayerStatus = async (
  state: IStore,
  groupId: number,
  gameId: number,
  status: string
): Promise<{ games?: IGamesStore; errors?: IErrorsStore }> => {
  const data = {
    status
  };
  const response = await request.patch(`${api.group(groupId)}games/${gameId}`, { data });

  if (response.error) {
    return { errors: { games: { msg: 'Error updating the game.' } } };
  }

  const updatedGame: IGame = response;

  return {
    games: {
      ...state.games,
      [updatedGame.id]: updatedGame
    }
  };
};
